import axios from "axios";
const moment = require("moment");

// import store from '../store';

function errorHandler(error, reject) {
  console.log(error);
  if (error.response && error.response.data) {
    reject(error.response.data);
  } else {
    reject(error);
  }
}

export default {
  list(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = [
          "page",
          "limit",
          "sortBy",
          "sortDir",
          "uraian",
          "DimCol",
          "DimVal",
          "tgl1",
          "tgl2",
          "nomor",
          "terimadari",
          "kodeacc",
          "namaacc",
          "kodebank",
          "paymethod",
          "trxgroup",
          "iogroup",
          "poststatus",
          "createby",
        ];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        const url = `/tranbank${str}`;
        const { data } = await axios.get(url);
        const { meta, list } = data;
        obj.total = meta.total;
        resolve(list);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  bankaccount() {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.get("/bankcashacc/allaccount");
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  bankacconly() {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.get("/bankcashacc/bankaccount");
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  byrsemu(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.get(`apinv/byrsemu/${obj.apinvkey}`);
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  byrsemuAdv(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.get(`advance/byrsemu/${obj.advanKey}`);
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  byrsemuAdvSet(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.get(`advsettle/byrsemu/${obj.advSttlKey}`);
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  byrsemuExp(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.get(`expense/byrsemu/${obj.expenKey}`);
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  currency() {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.get("/currency/cbo");
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  paymentdetail(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.get(`tranbank/paymentdetail/${obj.id}`);
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  receiptdetail(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.get(`tranbank/receiptdetail/${obj.id}`);
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  postingPayment(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        await axios.put(`tranbank/postingpayment/${obj.trbankkey}`);
        resolve();
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  postingReceipt(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        await axios.put(`tranbank/postingreceipt/${obj.trbankkey}`);
        resolve();
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  postingUndo(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        await axios.put(`tranbank/postingundo/${obj.trbankkey}`);
        resolve();
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  postingPaymentMultiple(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        // await axios.post(`tranbank/posting-bulk-bank`,obj);
        await axios.post(`tranbank/postingpayment-multiple`, obj);
        postingReceiptMultiple;
        resolve();
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  postingReceiptMultiple(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        await axios.post(`tranbank/postingreceipt-multiple`, obj);
        resolve();
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  postingMultiple(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        await axios.post(`tranbank/posting-multiple`, obj);
        resolve();
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  unpostingMultiple(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        // await axios.post(`tranbank/unposting-bulk-bank`,obj);
        await axios.post(`tranbank/unposting-multiple`, obj);
        resolve();
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  printjvPaymentMultiple(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.post(`tranbank/printpaymentjv-multiple`, obj);
        const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`;
        resolve(link);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  printjvReceiptMultiple(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.post(`tranbank/printreceivejv-multiple`, obj);
        const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`;
        resolve(link);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  print(obj = {}) {
    return new Promise(async (resolve, reject) => {
      let url;
      let str = "";
      try {
        str = "?key=" + encodeURIComponent(obj.trbankkey);
        if (obj.nomor.substr(1, 1) == "M") {
          url = `/tranbank/printreceive`;
        } else {
          url = `/tranbank/printpayment`;
        }

        url += str;
        const { data } = await axios.get(url);
        const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`;
        resolve(link);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  printjv(obj = {}) {
    return new Promise(async (resolve, reject) => {
      let url;
      let str = "";
      try {
        str = "?key=" + encodeURIComponent(obj.trbankkey);
        if (obj.nomor.substr(1, 1) == "M" || obj.bank_in != 0) {
          url = `/tranbank/printreceivejv`;
        } else {
          url = `/tranbank/printpaymentjv`;
        }

        url += str;
        const { data } = await axios.get(url);
        const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`;
        resolve(link);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  printkwitansi(obj = {}) {
    return new Promise(async (resolve, reject) => {
      let url;
      let str = "";
      try {
        str = "?key=" + encodeURIComponent(obj.trbankkey);
        url = `/tranbank/printkwitansi`;
        url += str;
        const { data } = await axios.get(url);
        const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`;
        resolve(link);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  insert(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.post("tranbank", obj);
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  remove(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.delete(`tranbank/${obj.trbankkey}`);
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  exportxls(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = [
          "sortBy",
          "sortDir",
          "uraian",
          "DimCol",
          "DimColInfo",
          "DimVal",
          "tgl1",
          "tgl2",
          "nomor",
          "terimadari",
          "kodeacc",
          "namaacc",
          "kodebank",
          "paymethod",
          "trxgroup",
          "iogroup",
          "poststatus",
          "createby",
        ];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }

        axios({
          url: `/tranbank/exportxls${str}`,
          method: "GET",
          responseType: "blob", // important
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `tran_cashbank_list_${moment().format("YYYYMMDDHHmm")}.xlsx`);
          document.body.appendChild(link);
          link.click();
          // window.location.assign(url);
          resolve(link);
        });
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  rekondb(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["kodebank", "kodeacc", "namaacc", "tgl1", "tgl2"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        const url = `/tranbank/rekondb${str}`;
        const { data } = await axios.get(url);
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  rekondbexport(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["kodebank", "kodeacc", "namaacc", "tgl1", "tgl2"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }

        axios({
          url: `/tranbank/rekondbexport${str}`,
          method: "GET",
          responseType: "blob", // important
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `tranbank_rekon_DB_${obj.tgl2}.xlsx`);
          document.body.appendChild(link);
          link.click();
          // window.location.assign(url);
          resolve(link);
        });
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  rekonkr(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["kodebank", "kodeacc", "namaacc", "tgl1", "tgl2"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        const url = `/tranbank/rekonkr${str}`;
        const { data } = await axios.get(url);
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  rekonkrexport(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["kodebank", "kodeacc", "namaacc", "tgl1", "tgl2"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }

        axios({
          url: `/tranbank/rekonkrexport${str}`,
          method: "GET",
          responseType: "blob", // important
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `tranbank_rekon_CR_${obj.tgl2}.xlsx`);
          document.body.appendChild(link);
          link.click();
          // window.location.assign(url);
          resolve(link);
        });
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },

  rptlist(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["page", "limit", "sortBy", "sortDir", "DimCol", "DimVal", "tgl1", "tgl2", "trxgroup", "iogroup", "kodeacc", "kodebank", "namaacc"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        const url = `/tranbank/rptlist${str}`;
        const { data } = await axios.get(url);
        const { meta, list } = data;
        obj.total = meta.total;
        resolve(list);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  rptexport(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ["sortBy", "sortDir", "DimCol", "DimColInfo", "DimVal", "tgl1", "tgl2", "trxgroup", "iogroup", "kodeacc", "kodebank", "namaacc"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }

        axios({
          url: `/tranbank/rptexport${str}`,
          method: "GET",
          responseType: "blob", // important
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `report_tran_cashbank_list_${moment().format("YYYYMMDDHHmm")}.xlsx`);
          document.body.appendChild(link);
          link.click();
          // window.location.assign(url);
          resolve(link);
        });
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  emailCheck(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.get(`/proctender/emailrfqcheck/${obj.idVendor}`);
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  emailVendor(obj = {}) {
    return new Promise(async (resolve, reject) => {
      let url;
      try {
        const keys = ["appaymkey", "contact_email"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }

        url = `/tranbank/emailvendor`;
        url += str;
        await axios.get(url);
        resolve();
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
};
